/**
 * Anger objektrepresentation av ett bebyggelseobjekts ändamål.
 */
export interface AndamalPut {
  /**
   * Anger referensen till identiteten för objektets ändamål. Identiteten kan avse såväl en huvudkategori eller underkategori.
   */
  andamal_id: number;
  /**
   * Anger typen av kategori som användaren gjorde avseende ursprungligt_andamal_id.
   */
  kategorityp?: AndamalPut.KategoritypEnum;
}

export namespace AndamalPut {
  export type KategoritypEnum = 'HUVUDKATEGORI' | 'UNDERKATEGORI';
  export const KategoritypEnum = {
    HUVUDKATEGORI: 'HUVUDKATEGORI' as KategoritypEnum,
    UNDERKATEGORI: 'UNDERKATEGORI' as KategoritypEnum
  };
}
